/**
 * Owner: Masa Bayu
 * File: bka-post-handoff-types.ts
 * Date:Time: 2026-09-22 18:17
 * Description: Post–Add Book handoff flag · report types · integrate-only · no new SoT.
 */
/** Feature flag — post–Add Book handoff under POST-HANDOFF BUILD AUTH. */
export const BKA_POST_HANDOFF_FEATURE_FLAG = Object.freeze({
    id: 'bka.post_add_book.handoff',
    defaultEnabledInProduction: false,
    wave: 'post-add-book',
    path: 'publish_to_qxread',
    adapterGate: 'POST-ADD-BOOK-HANDOFF-AUTH',
    integrateOnly: true,
    inventsCatalog: false,
    inventsEntitlement: false,
    inventsPe1: false,
    inventsQxread: false,
    maySourceToQxp: false,
    mayAdamToQxp: false,
    doc03Undisturbed: true,
});
//# sourceMappingURL=bka-post-handoff-types.js.map